import { LoaderUtils } from 'three';
import { SESSION_STORAGE } from './constants';
export class Util {
  static AsteriskReplace(text: string): string {
    return text.substring(text.length - 2).padStart(text.length, '*');
  }

  public static isString(value: any): boolean {
    let returnValue: boolean = typeof value === 'string';
    if (returnValue) {
      returnValue = !(value as string).includes('{');
    }
    return returnValue;
  }

  public static isJson(value: any): boolean {
    let returnValue = false;
    if (typeof value !== 'object') {
      returnValue = (value as string).includes('{');
    }
    return returnValue;
  }

  public static isMobile(): boolean {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  public static isiOS(): boolean {
    const toMatch = [/iPhone/i, /iPad/i, /iPod/i];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  public static logoff(): void {
    sessionStorage.removeItem(SESSION_STORAGE.TOKEN);
    sessionStorage.removeItem(SESSION_STORAGE.USER);
  }

  public static youtubeRegex(url: string): string {
    if (Util.isYoutube(url)) {
      url = `https://www.youtube.com/embed/${Util.getYoutubeId(url)}?autoplay=1&enablejsapi=1`;
    }
    return url;
  }

  public static isYoutube(url: string): boolean {
    const pattern = /(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/\S*?[^\w\s-])((?!videoseries)[\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/;
    const reg: RegExp = new RegExp(pattern, 'gim');
    const _RESULT = reg.exec(url);

    return !Util.isNullOrUndefined(_RESULT);
  }

  public static getYoutubeId(url: string): string {
    const pattern = /(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/\S*?[^\w\s-])((?!videoseries)[\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/;
    const reg: RegExp = new RegExp(pattern, 'gim');
    const _RESULT = reg.exec(url);

    return !Util.isNullOrUndefined(_RESULT) ? _RESULT[1] : url;
  }

  public static isNullOrUndefined(objectValue: any): boolean {
    return (
      objectValue === null ||
      objectValue?.length <= 0 ||
      objectValue === undefined ||
      objectValue === 'undefined' ||
      objectValue === '' ||
      objectValue === '{}'
    );
  }

  public static compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Remove acentos de strings
   * @param  texto string acentuada
   * @return string sem acento
   */
  public static clearAccent(texto: string, minusculas = false): string {
    const map = {
      â: 'a',
      Â: 'A',
      à: 'a',
      À: 'A',
      á: 'a',
      Á: 'A',
      ã: 'a',
      Ã: 'A',
      ê: 'e',
      Ê: 'E',
      è: 'e',
      È: 'E',
      é: 'e',
      É: 'E',
      î: 'i',
      Î: 'I',
      ì: 'i',
      Ì: 'I',
      í: 'i',
      Í: 'I',
      õ: 'o',
      Õ: 'O',
      ô: 'o',
      Ô: 'O',
      ò: 'o',
      Ò: 'O',
      ó: 'o',
      Ó: 'O',
      ü: 'u',
      Ü: 'U',
      û: 'u',
      Û: 'U',
      ú: 'u',
      Ú: 'U',
      ù: 'u',
      Ù: 'U',
      ç: 'c',
      Ç: 'C',
    };
    let retorno = null;

    if (minusculas) {
      retorno = texto.replace(/[\W\[\] ]/g, (a) => map[a] || a).toLowerCase();
    } else {
      retorno = texto.replace(/[\W\[\] ]/g, (a) => map[a] || a);
    }
    return retorno;
  }

  public static ab2str(arrayBuffer): string {
    // const uint16Array = new Uint8Array(arrayBuffer);
    // const data = uint16Array.reduce((acc, i) => acc += String.fromCharCode.apply(null, [i]), '');
    // return data;
    // return LoaderUtils.decodeText(new Uint16Array(arrayBuffer));
    const array64 = this.arrayBufferToBase64(arrayBuffer);
    return atob(array64);
  }

  public static ab2json(arrayBuffer): any {
    const str = this.ab2str(arrayBuffer);
    return this.isJson(str) ? JSON.parse(str) : str;
  }

  public static str2ab(str): ArrayBuffer {
    const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
    const bufView = new Uint16Array(buf);

    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }

    return buf;
  }

  public static arrayBufferToBase64(buffer: ArrayBufferLike): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  }

  public static base64ToArrayBuffer(base64: string): ArrayBufferLike {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  public static decodeBase64(base64String: string): string {
    const binaryString = atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  }

  public static isAbv(value) {
    return value && value instanceof ArrayBuffer && value.byteLength !== undefined;
  }

  public static omitKeys(obj, keys, level?) {
    const dup = {};
    // level--;
    for (const key in obj) {
      if (keys.indexOf(key) === -1) {
        // if (level > 0) {
        //   dup[key] = Util.omitKeys(obj[key], keys, level);
        // }
        // else
        {
          dup[key] = obj[key];
        }
      }
    }
    return dup;
  }

  public static LargestCanonicalAxisDirection(v1): string {
    let canonicalAxis = this.LargestCanonicalAxis(v1);
    if (canonicalAxis === 'PositiveY' || canonicalAxis === 'NegativeY') {
      return 'y'
    }
    if (canonicalAxis === 'PositiveX' || canonicalAxis === 'NegativeX') {
      return 'x'
    }
    if (canonicalAxis === 'PositiveZ' || canonicalAxis === 'NegativeZ') {
      return 'z'
    }
  }

  public static LargestCanonicalAxis(v1): string {
    let canonicalAxis = 'None';

    v1.normalize();

    // select largest abs coordinate axis
    const absX = Math.abs(v1.x);
    const absY = Math.abs(v1.y);
    const absZ = Math.abs(v1.z);
    const epsilon = 0.0001;

    if (absX < epsilon) {
      if (absY > absZ) {
        canonicalAxis = v1.y > 0 ? 'PositiveY' : 'NegativeY';
      } else {
        canonicalAxis = v1.z > 0 ? 'PositiveZ' : 'NegativeZ';
      }
    } else if (absY < epsilon) {
      if (absX > absZ) {
        canonicalAxis = v1.x > 0 ? 'PositiveX' : 'NegativeX';
      } else {
        canonicalAxis = v1.z > 0 ? 'PositiveZ' : 'NegativeZ';
      }
    } else if (absZ < epsilon) {
      if (absX > absY) {
        canonicalAxis = v1.x > 0 ? 'PositiveX' : 'NegativeX';
      } else {
        canonicalAxis = v1.y > 0 ? 'PositiveY' : 'NegativeY';
      }
    } else if (absX > absY && absX > absZ) {
      canonicalAxis = v1.x > 0 ? 'PositiveX' : 'NegativeX';
    } else if (absY > absZ && absY > absX) {
      canonicalAxis = v1.y > 0 ? 'PositiveY' : 'NegativeY';
    } else {
      canonicalAxis = v1.z > 0 ? 'PositiveZ' : 'NegativeZ';
    }

    return canonicalAxis;
  }

  public static LargestCanonicalAxisValue(v1) {
    let canonicalAxis = [1, 0, 0];

    v1.normalize();

    // select largest abs coordinate axis
    const absX = Math.abs(v1.x);
    const absY = Math.abs(v1.y);
    const absZ = Math.abs(v1.z);
    const epsilon = 0.0001;

    if (absX < epsilon) {
      if (absY > absZ) {
        canonicalAxis = v1.y > 0 ? [0, 1, 0] : [0, -1, 0];
      } else {
        canonicalAxis = v1.z > 0 ? [0, 0, 1] : [0, 0, -1];
      }
    } else if (absY < epsilon) {
      if (absX > absZ) {
        canonicalAxis = v1.x > 0 ? [1, 0, 0] : [-1, 0, 0];
      } else {
        canonicalAxis = v1.z > 0 ? [0, 0, 1] : [0, 0, -1];
      }
    } else if (absZ < epsilon) {
      if (absX > absY) {
        canonicalAxis = v1.x > 0 ? [1, 0, 0] : [-1, 0, 0];
      } else {
        canonicalAxis = v1.y > 0 ? [0, 1, 0] : [0, -1, 0];
      }
    } else if (absX > absY && absX > absZ) {
      canonicalAxis = v1.x > 0 ? [1, 0, 0] : [-1, 0, 0];
    } else if (absY > absZ && absY > absX) {
      canonicalAxis = v1.y > 0 ? [0, 1, 0] : [0, -1, 0];
    } else {
      canonicalAxis = v1.z > 0 ? [0, 0, 1] : [0, 0, -1];
    }

    return canonicalAxis;
  }

  public static getCanonicalAxisRotation(v1) {
    const canonicalAxis = this.LargestCanonicalAxis(v1);
    switch (canonicalAxis) {
      case 'PositiveZ':
        return [0, 0, 1];
        break;
      case 'NegativeZ':
        return [0, 0, 1];
        break;
      case 'PositiveY':
        return [1, 0, 0];
        break;
      case 'NegativeY':
        return [1, 0, 0];
        break;

      default:
        break;
    }
  }

  public static getAreaFromBBWithNormal(size, normal) {
    const largestCanonicalAxis = Util.LargestCanonicalAxis(normal);
    switch (largestCanonicalAxis) {
      case 'PositiveX':
        return size.y * size.z;
        break;
      case 'NegativeX':
        return size.y * size.z;
        break;
      case 'PositiveZ':
        return size.y * size.x;
        break;
      case 'NegativeZ':
        return size.y * size.x;
        break;
      case 'PositiveY':
        return size.x * size.z;
        break;
      case 'NegativeY':
        return size.x * size.z;
        break;
      default:
        break;
    }
  }

  public static sleep(seconds) {
    var e = new Date().getTime() + (seconds * 1000);
    while (new Date().getTime() <= e) { }
  }

  public static arr_diff(a1, a2) {
    var a = [], diff = [];
    for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }

    for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }

    for (var k in a) {
      diff.push(k);
    }

    return diff;
  }

  public static arr_diffab(a1, a2) {
    var a = [];

    for (let i = 0; i < a1.length; i++) {
      if (!a2.find(x => x === a1[i])) {
        a.push(a1[i]);
      }
    }
    return a;
  }

  public static groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
    list.reduce((previous, currentItem) => {
      const group = getKey(currentItem);
      if (!previous[group]) previous[group] = [];
      previous[group].push(currentItem);
      return previous;
    }, {} as Record<K, T[]>);


  public static _objectWithoutProperties(obj: any, keys: any[]): any {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
}
